import EditUserFormContainer from './edit-user-form-container';

export default EditUserFormContainer;
